import { useHistory } from 'react-router-dom';
import styles from './NotFound.module.scss';

const NotFound = () => {
  const history = useHistory();
  return (
    <div className={styles.webhooks}>
      <h3>Opss! Looks like you took a wrong turn</h3>
      <button onClick={() => history.goBack()}>Go Back</button>
    </div>
  );
};

export default NotFound;
